import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { useTranslate } from '@im/react-localization';
import { MarginStrategy } from '../../hooks/rule-submit';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import PricingExample from './PricingExample';

const style = {
  bgcolor: 'background.paper',
  left: '50%',
  p: 4,
  position: 'absolute' as const,
  top: '50%',
  transform: 'translate(-50%, -50%)',
};

const PricingMarginStrategy = (props: {
  error?: string | null;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: MarginStrategy
  ) => void;
  value?: MarginStrategy | null;
}) => {
  const translate = useTranslate();
  const options = [
    {
      label: translate('Pricing.MarginStrategyReplacementCost'),
      value: 'REPLACEMENT_COST',
    },
    {
      label: translate('Pricing.MarginStrategyRetailPrice'),
      value: 'RETAIL_PRICE',
    },
  ] as const;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <FormControl
      data-testid="pricing-margin-strategy"
      error={Boolean(props.error)}
    >
      <FormLabel
        htmlFor="margin-strategy-options"
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontSize: '0.875rem',
        }}
      >
        {translate('Pricing.MarginStrategyPrompt')}
      </FormLabel>
      <Stack alignItems={'center'} direction="row">
        <RadioGroup
          id="margin-strategy-options"
          onChange={props.onChange as any}
          row
          value={props.value ?? null}
        >
          {options.map((o) => (
            <FormControlLabel
              componentsProps={{ typography: { variant: 'body2' } }}
              control={<Radio />}
              key={o.value}
              label={o.label}
              value={o.value}
            />
          ))}
        </RadioGroup>
        <Stack>
          <Button
            onClick={handleOpen}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              outline: 'none',
              textTransform: 'none',
            }}
          >
            {translate('Pricing.Wt')}
          </Button>
          <Modal
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={open}
          >
            <Box flex={1} mt={3} sx={style}>
              <PricingExample setOpen={setOpen} />
            </Box>
          </Modal>
        </Stack>
      </Stack>
      <FormHelperText sx={{ ml: 0 }}>{props.error}</FormHelperText>
    </FormControl>
  );
};

export default PricingMarginStrategy;
